// services/mappers/drone.js

const setWeapon = (el = {}) => ({
  drone: el?.Drone ?? null,
  droneID: el?.DroneID ?? null,
  id: el?.ID ?? null,
  iconURL: el?.IconURL ?? null,
  rounds_remaining: el?.RoundsRemaining ?? null,
  total_rounds: el?.TotalRounds ?? null,
  type: el?.Type ?? null,
});

export const setDrone = (el = {}) => ({
  createdAt: el?.CreatedAt || null,
  updatedAt: el?.UpdatedAt || null,
  deletedAt: el?.DeletedAt || null,
  id: el?.ID || null,
  display_id: el?.display_id || null,
  device_id: el?.device_id || null,
  drone_ip: el?.drone_ip || null,
  drone_number: el?.drone_number || 0,
  created_by_id: el?.created_by_id || null,
  campus_id: el?.campus_id || null,
  type: el?.type || null,
  nest_id: el?.nest_id || null,
  added_by_id: el?.added_by_id || null,
  status: el?.status || null,
  battery_level: el?.battery_level || 0,
  charging_status: el?.charging_status || null,
  last_used_at: el?.last_used_at || null,
  manufacturer: el?.manufacturer || null,
  // base_station_ip: el?.base_station_ip || null,
  flight_hours: el?.flight_hours || 0,
  primary_camera_port: el?.primary_camera_port || 0,
  secondary_camera_port: el?.secondary_camera_port || 0,
  mic_port: el?.mic_port || 0,
  speaker_port: el?.speaker_port || 0,
  crsf_control_port: el?.crsf_control_port || 0,
  crsf_telem_port: el?.crsf_telem_port || 0,
  location: el?.location || null,
  weapon: Array.isArray(el?.weapon) ? el?.weapon.map(setWeapon) : [],
});
